// extracted by mini-css-extract-plugin
export var pillWrapper = "_kc-0";
export var showOverflow = "_kc-1";